module.exports = __webpack_public_path__ + "img/selected3-min.7253503c.png";